/**
 * Created by mly on 2017/12/5.
 * 增删改查公用 数据 和 方法
 * 组件使用 mixins 引入
 */
import Util from '../../libs/util';
export default {
    data(){
        return {
            params: {
                search: '',
                per_page: 20,
                page: 1,
            },
            large_page_params: {
                search: '',
                per_page: 500,
                page: 1,
            },
            items: [],
            // interface
            item_columns: [
                {
                    title: '名称',
                    key: 'name'
                }
            ],
            edit_item: {},
            loading: false,
            page_info: {
                current: 1,
                total: 0,
                page_size: 1
            },
            edit_config: {
                modal: false,
                loading: true
            }
        }
    },
    created(){
        //
    },
    mounted(){
        this.doSearch();
    },
    methods: {
        doSearch(){
            this.$refs.searchBtn.doAjax();
        },
        pageChange(new_page){
            this.params.page = new_page;
            this.loading = true;
            this.$refs.searchBtn.doAjax(true);
        },
        beforeSearch(){
            this.params.page = 1;
            this.loading = true;
            this.empty_tip = '获取数据中...';
            this.customers = [];
        },
        handleData(data){
            this.loading = false;
            this.items = [];
            data.items.forEach((item)=>{
                this.items.push(item);
            });
            if(data.items.length === 0){
                this.empty_tip = '没有结果, 请重试!';
            }
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
        },
        handleFail(e){
            this.loading = false;
            this.empty_tip = '获取数据失败, 请重试';
            console.log(e);
        },
        editItem(item){
            this.edit_item = Util.clone(item);
            this.edit_config.modal = true;
        },
        checkValid(){
            return true;
        },
        editOk(){
            if(this.checkValid()){
                Util.ajax.post(this.update_item_path, this.edit_item).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        this.edit_config.modal = false;
                        Util.insertOrUpdateArrayItem(this.items, res.item, true);
                        this.$Message.success({
                            content: '保存成功!'
                        });
                    }else{
                        this.resetEditLoading();
                        this.$Modal.error({
                            title: '提示',
                            content: this.genErrorMsg(res.msg)
                        })
                    }
                }).catch((e)=>{
                    this.resetEditLoading();
                    console.log(e);
                    this.$Message.error({
                        title: '提示',
                        content: '操作失败!'
                    });
                });
            }else{
                this.resetEditLoading();
            }
        },
        genErrorMsg(msg){
            let content = '';
            if(typeof msg === 'string'){
                content = msg;
            }else if(typeof msg === 'object'){
                Object.keys(msg).forEach((key)=>{
                    content += `<p>${msg[key]}</p>`;
                });
            }
            return content;
        },
        resetEditLoading(){
            this.edit_config.loading = false;
            setTimeout(()=>{
                this.edit_config.loading = true;
            }, 500);
        }
    }
}
